import { render, staticRenderFns } from "./copyrightEscrow.vue?vue&type=template&id=bf349e42&scoped=true&"
import script from "./copyrightEscrow.vue?vue&type=script&lang=js&"
export * from "./copyrightEscrow.vue?vue&type=script&lang=js&"
import style0 from "./copyrightEscrow.vue?vue&type=style&index=0&id=bf349e42&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf349e42",
  null
  
)

export default component.exports